import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from './models/api-response';
import { GenericItem } from './models/generic-item';
import { GenericList } from './models/generic-list';
import { MaintUser } from './models/maint-user';
import { MaintUserSearchConditions } from './models/maint-user-search-conditions';

import { ServicerProvider } from './servicer';

const BASE_URL = '/v2/system/maint/users';

/**
 * [システム] [メンテナンス] ユーザ のプロバイダー.
 */
@Injectable()
export class SystemMaintUsersServiceProvider {

  constructor(
    private servicer: ServicerProvider
  ) { }

  /**
   * ユーザ一覧取得処理.
   * 
   * @param searchConditions 検索条件
   * @returns Observable<GenericList<MaintUser>>
   */
  list(searchConditions?: MaintUserSearchConditions): Observable<GenericList<MaintUser>> {
    return this.servicer.list(BASE_URL, searchConditions);
  }

  /**
   * ユーザ取得処理.
   * 
   * @param id ユーザID
   * @returns Observable<MaintUser>
   */
  get(id: number): Observable<GenericItem<MaintUser>> {
    const url = `${ BASE_URL }/${ id }`;
    return this.servicer.get<GenericItem<MaintUser>>(url);
  }

  /**
   * ユーザ登録処理.
   *
   * @param data 入力データ
   * @returns Observable<ApiResponse>
   */
  post(data: MaintUser): Observable<GenericItem<number>> {
    return this.servicer.postApi<MaintUser, GenericItem<number>>(BASE_URL, data);
  }

  /**
   * ユーザ保存処理.
   *
   * @param data 入力データ
   * @returns Observable<ApiResponse>
   */
  patch(data: MaintUser): Observable<ApiResponse> {
    const url = `${ BASE_URL }/${ data.id }`;
    return this.servicer.patch<MaintUser, ApiResponse>(url, data);
  }

  /**
   * ユーザ削除処理.
   *
   * @param id ユーザID
   * @returns Observable<ApiResponse>
   */
  delete(id: number): Observable<ApiResponse> {
    const url = `${ BASE_URL }/${ id }`;
    return this.servicer.delete<ApiResponse>(url);
  }

  /**
   * 顔認証登録.
   *
   * @param data FaceRegist
   * @returns Observable<ApiResponse>
   */
  postFace(userId: number, file: Blob): Observable<ApiResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${ BASE_URL }/${ userId }/face`;
    return this.servicer.postFormData<ApiResponse>(url, formData);
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-maint-users-service.ts